import { Component } from '@angular/core';
import { SystemCapabilityService } from 'src/app/services/system-capabilities/system-capability.service';
import { AddDeviceMainTabComponent } from '../add-device/add-device-main-tab.component';
import { BreadcrumbLabelDirective } from '../../../directives/breadcrumb-label.directive';

@Component({
	selector: 'app-migrate-devices-tab',
	templateUrl: './migrate-devices-tab.component.html',
	styleUrls: [
		'./migrate-devices-tab.component.scss',
		'../../../ui/common/main.scss',
		'../../../ui/common/stepper.scss',
	],
	imports: [AddDeviceMainTabComponent, BreadcrumbLabelDirective],
})
export class MigrateDevicesTabComponent {
	isOracle = false;
	showImportDevicesScreen = false;
	showTransferDevicesScreen = false;
	importDeviceBreadcrumbLabel = $localize`:@@migrateDevicesTab-breadcrumbImportLabel:Import Devices`;
	transferDeviceBreadcrumbLabel = $localize`:@@migrateDevicesTab-breadcrumbTransferLabel:Transfer Devices`;

	constructor(private readonly scService: SystemCapabilityService) {
		this.isOracle = this.scService.isOracle;
	}

	onImportDevicesContinueClicked(): void {
		this.showImportDevicesScreen = true;
	}

	onTransferDevicesContinueClicked(): void {
		this.showTransferDevicesScreen = true;
	}

	goBack(event: boolean) {
		this.showImportDevicesScreen = false;
		this.showTransferDevicesScreen = false;
	}

	getSCService() {
		return this.scService;
	}
}
